import { render, staticRenderFns } from "./WkDep.vue?vue&type=template&id=28e3c4fc&scoped=true&"
import script from "./WkDep.vue?vue&type=script&lang=js&"
export * from "./WkDep.vue?vue&type=script&lang=js&"
import style0 from "./WkDep.vue?vue&type=style&index=0&id=28e3c4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3c4fc",
  null
  
)

component.options.__file = "WkDep.vue"
export default component.exports